<template>
  <div class="table-container">
    <button class="vca-button-small table-header-option" @click="excelExport">
      {{ $t("button.export_excel") }}
    </button>
    <VcaTable
      store="takings"
      :list="pg_list"
      :colspan="8"
      :searchLabel="$t('taking.list.search')"
    >
      <template v-slot:colspan>
        <col width="12%" />
        <col width="12%" />
        <col width="12%" />
        <col width="8%" />
        <col width="4%" />
        <col width="4%" />
        <col width="4%" />
        <col width="1%" />
      </template>
      <template v-slot:desktop-filter>
        <vca-accordion :header="$t('taking.list.filter')">
          <div slot="body">
            <TakingFilter v-model="filter" @reset="resetFilter()" />
          </div>
        </vca-accordion>
      </template>
      <template v-slot:desktop-options> </template>
      <template v-slot:desktop-header>
        <th class="vca-table-cell sortable" @click="sort('name')">
          <label> {{ $t("taking.list.name") }} &varr;</label>
        </th>
        <th class="vca-table-cell sortable" @click="sort('event.name')">
          <label> {{ $t("taking.list.to_event") }} &varr;</label>
        </th>
        <th class="vca-table-cell sortable" @click="sort('date_of_taking')">
          <label> {{ $t("taking.list.date_of_taking") }} &varr;</label>
        </th>
        <th class="vca-table-cell sortable" @click="sort('state.open.amount')">
          <label> {{ $t("taking.list.open") }} &varr;</label>
        </th>
        <th class="vca-table-cell sortable" @click="sort('state.wait.amount')">
          <label> {{ $t("taking.list.wait") }} &varr;</label>
        </th>
        <th
          class="vca-table-cell sortable"
          @click="sort('state.confirmed.amount')"
        >
          <label> {{ $t("taking.list.confirmed") }} &varr;</label>
        </th>
        <th class="vca-table-cell sortable" @click="sort('crew.name')">
          <label> {{ $t("taking.list.crew_name") }} &varr;</label>
        </th>
        <th class="vca-table-cell">
          <label>{{ $t("table.options") }}</label>
        </th>
      </template>
      <template v-slot:desktop-content>
        <tr
          class="vca-table-row"
          @click="setCurrent(res)"
          :class="{ last: index + 1 == pg.pageSize }"
          v-for="(res, index) in pg_list"
          :key="index"
        >
          <td class="vca-table-cell">
            <a :href="takingLink(res.id)"> {{ takingName(res) }}</a>
          </td>
          <td class="vca-table-cell">
            <a :href="eventLink(res.event.id)"> {{ res.event.name }}</a>
          </td>
          <td class="vca-table-cell">
            {{ dataOfTaking(res.date_of_taking) }}
          </td>
          <td class="vca-table-cell">
            <label>
              {{ formatMoneyStatus(res.state, "open") }}
            </label>
          </td>
          <td class="vca-table-cell">
            <label>
              {{ formatMoneyStatus(res.state, "wait") }}
            </label>
          </td>
          <td class="vca-table-cell">
            <label>
              {{ formatMoneyStatus(res.state, "confirmed") }}
            </label>
          </td>
          <td class="vca-table-cell">
            <label>
              {{ res.crew.name }} {{ res.organisation.abbreviation }}
            </label>
          </td>

          <td class="vca-table-cell">
            <vca-row>
              <a :href="edit(res.id)"
                ><img
                  class="editable"
                  src="@/assets/icons/edit.png"
                  :title="$t('button.edit')"
                  :alt="$t('button.edit')"
              /></a>
              <label
                class="editable"
                @click="remove(res.id)"
                v-if="showRemove(res)"
                ><img
                  class="editable"
                  src="@/assets/icons/delete.png"
                  :title="$t('button.delete')"
                  :alt="$t('button.delete')"
              /></label>
            </vca-row>
          </td>
        </tr>
      </template>
      <template v-slot:mobile-filter>
        <button class="vca-button" @click="do_filter = true">
          {{ $t("taking.list.filter") }}
        </button>
        <vca-popup
          v-if="do_filter"
          :show="do_filter"
          :title="$t('taking.list.filter')"
          @close="do_filter = false"
        >
          <TakingFilter v-model="filter" />
        </vca-popup>
      </template>
      <template v-slot:mobile-header>
        <div class="sortable" @click="sort('name')">
          <label>{{ $t("taking.list.name") }} &varr;</label>
        </div>
        <div>
          <label>{{ $t("taking.list.amounts") }}</label>
        </div>
      </template>
      <template v-slot:mobile-content>
        <tr
          class="vca-table-row"
          :class="{ last: index + 1 == pg.pageSize }"
          v-for="(res, index) in pg_list"
          :key="index"
        >
          <td class="vca-table-cell">
            <vca-column>
              <vca-row @click="setCurrent(res)">
                <div class="vca-table-index">
                  <a :href="takingLink(res.id)">
                    {{ takingName(res) }}
                  </a>
                  <br />
                  <small>{{ dataOfTaking(res.date_of_taking) }}</small>
                </div>
                <div class="vca-table-index" v-if="!res.state.no_income">
                  {{ formatMoneyStatus(res.state, "open") }} /
                  {{ formatMoneyStatus(res.state, "wait") }} /
                  {{ formatMoneyStatus(res.state, "confirmed") }}
                </div>
                <div class="vca-table-index" v-if="res.state.no_income">
                  {{ $t("taking.list.no_income") }}
                </div>
              </vca-row>
            </vca-column>
          </td>
        </tr>
      </template>
    </VcaTable>
  </div>
</template>
<script>
import TakingFilter from "@/components/finance/takings/list/TakingFilter";
import VcaTable from "@/components/utils/VcaTable";
import { mapGetters, mapState } from "vuex";
import * as XLSX from "xlsx";
export default {
  name: "TakingTable",
  components: { VcaTable, TakingFilter },
  data() {
    return {
      store: "takings/pg",
      initial: true,
      do_filter: false,
      currentFilter: {
        type_of_event: [],
        event_end_to: undefined,
        event_end_from: undefined,
      },
      currentTextFilter: "",
      updateCount: 0,
    };
  },
  watch: {
    "pg.currentPage": {
      handler() {
        this.$store.dispatch({ type: `${this.store}/request` });
      },
      deep: true,
    },
    "pg.pageSize": {
      handler(value) {
        this.$store.commit(`${this.store}/pageSize`, value);
        if (this.pg.currentPageSize == 1) {
          this.$store.dispatch({ type: `${this.store}/request` });
        }
      },
      deep: true,
    },
    "pg.filterObject": {
      handler() {
        this.$store.dispatch({
          type: `${this.store}/request`,
          data: { inital: true, abort: true },
        });
      },
      deep: true,
    },
    "pg.filter": {
      handler() {
        this.$store.dispatch({
          type: `${this.store}/request`,
          data: { inital: true, abort: true },
        });
      },
      deep: true,
    },
  },
  created() {
    this.resetFilter();
  },
  computed: {
    filter: {
      set(value) {
        this.pg.filterObject = value;
      },
      get() {
        return this.pg.filterObject;
      },
    },
    ...mapState({
      pg(state, getters) {
        if (this.store) {
          return getters[`${this.store}/pagination`];
        }
      },
    }),
    ...mapGetters({
      hasSystemPermission: "user/roles/hasSystemPermission",
      pg_list: "takings/pg/list",
    }),
    emptyFilter() {
      return !this.pg.filter || this.pg.filter == "";
    },
    sameFilter() {
      return (
        Object.entries(this.currentFilter).toString() ===
          Object.entries(this.filter).toString() &&
        this.currentTextFilter == this.pg.filter
      );
    },
  },
  methods: {
    get_ymd_date() {
      let dateNow = new Date(Date.now());
      const month = (dateNow.getMonth() + 1).toString().padStart(2, "0");
      const day = dateNow.getDate().toString().padStart(2, "0");
      return dateNow.getFullYear() + "_" + month + "_" + day;
    },
    excelExport() {
      let columns = [
        this.$t("taking.excel.taking_name"),
        this.$t("taking.excel.taking_date"),
        this.$t("taking.excel.event_name"),
        this.$t("taking.excel.event_type"),
        this.$t("taking.excel.event_from_date"),
        this.$t("taking.excel.event_to_date"),
        this.$t("taking.excel.crew_name"),
        this.$t("taking.sources.can.title"),
        this.$t("taking.sources.box.title"),
        this.$t("taking.sources.gl.title"),
        this.$t("taking.sources.other.title"),
        this.$t("taking.sources.unknown.title"),
        this.$t("taking.sources.merch.title"),
        this.$t("taking.sources.other_ec.title"),
        this.$t("taking.excel.taking_money"),
        this.$t("taking.excel.taking_created"),
        this.$t("taking.excel.taking_id"),
        this.$t("taking.excel.event_id"),
        this.$t("taking.sources.can.title"),
        this.$t("taking.sources.box.title"),
        this.$t("taking.sources.gl.title"),
        this.$t("taking.sources.other.title"),
        this.$t("taking.sources.unknown.title"),
        this.$t("taking.sources.merch.title"),
        this.$t("taking.sources.other_ec.title"),
      ];

      let data = [[], columns];
      const eventUUIDs = new Set();
      this.pg_list.forEach((taking) => {
        let eventName = "-";
        let eventId = undefined;
        let eventType = "-";
        let date_taking = "";
        let eventFromDate = "-";
        let eventToDate = "-";
        if (taking.event.id !== "") {
          eventId = taking.event.id;
          eventUUIDs.add(eventId);
          eventName = taking.event.name;
          eventType =
            taking.event.type_of_event !== ""
              ? this.$t(
                  "events.eventtypes." + taking.event.type_of_event + ".label"
                )
              : "-";

          eventFromDate = new Date(taking.event.start_at * 1000);
          eventToDate = new Date(taking.event.end_at * 1000);
        }
        if (taking.date_of_taking > 0) {
          date_taking = new Date(taking.date_of_taking * 1000);
        }
        let taking_created = new Date(taking.modified.created * 1000);

        let sources = {
          can: { money: "-", comment: " " },
          box: { money: "-", comment: " " },
          gl: { money: "-", comment: " " },
          other: { money: "-", comment: " " },
          unknown: { money: "-", comment: " " },
          merch: { money: "-", comment: " " },
          other_ec: { money: "-", comment: " " },
        };

        taking.sources.forEach((source) => {
          sources[source.value]["money"] = source.money.amount / 100;
          if (source.description && source.description.length > 0) {
            sources[source.value]["comment"] = source.description;
          }
        });

        let entry = [
          taking.name,
          date_taking,
          eventName,
          eventType,
          eventFromDate,
          eventToDate,
          taking.crew.name,
          sources["can"]["money"],
          sources["box"]["money"],
          sources["gl"]["money"],
          sources["other"]["money"],
          sources["unknown"]["money"],
          sources["merch"]["money"],
          sources["other_ec"]["money"],
          taking.money.amount / 100,
          taking_created,
          taking.id,
          eventId,
          sources["can"]["comment"],
          sources["box"]["comment"],
          sources["gl"]["comment"],
          sources["other"]["comment"],
          sources["unknown"]["comment"],
          sources["merch"]["comment"],
          sources["other_ec"]["comment"],
        ];
        data.push(entry);
      });

      let filename =
        "VcA_Pool_Finanzen_Einnahmen_" + this.get_ymd_date() + ".xlsx";
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(data);

      // https://docs.sheetjs.com/docs/csf/features/colprops#column-widths
      ws["!cols"] = [
        { wch: 20 }, // A
        { wch: 10 },
        { wch: 20 },
        { wch: 11 },
        { wch: 10 },
        { wch: 10 }, // F
        { wch: 12 },
        { wch: 11 },
        { wch: 11 },
        { wch: 11 },
        { wch: 11 },
        { wch: 11 },
        { wch: 11 },
        { wch: 11 },
        { wch: 14 },
        { wch: 20 },
        { wch: 3 },
        { wch: 3 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
      ];

      ws["!autofilter"] = { ref: "A2:Y" + data.length };

      const COL_OFFSET = 3;
      for (let i = COL_OFFSET; i <= data.length; ++i) {
        ws["H" + i].z = "0.00 €";
        ws["I" + i].z = "0.00 €";
        ws["J" + i].z = "0.00 €";
        ws["K" + i].z = "0.00 €";
        ws["L" + i].z = "0.00 €";
        ws["M" + i].z = "0.00 €";
        ws["N" + i].z = "0.00 €";
        ws["O" + i].z = "0.00 €";
        ws["B" + i].z = "dd.mm.yyyy";
        ws["E" + i].z = "dd.mm.yyyy";
        ws["F" + i].z = "dd.mm.yyyy";
        ws["P" + i].z = "dd.mm.yyyy";

        if (data[i - 1][17] !== undefined) {
          ws["C" + i].l = {
            Target: "https://pool3.vivaconagua.org/events/" + data[i - 1][17],
          };
        }

        if (data[i - 1][16] !== undefined) {
          ws["A" + i].l = {
            Target:
              "https://pool3.vivaconagua.org/finances/takings/edit/" +
              data[i - 1][16],
          };
        }
      }

      ws["O1"] = {
        f: "SUM(O3:O" + data.length + ")",
        z: "0.00 €",
      };

      ws["C1"] = { v: "Event" };
      ws["H1"] = { v: this.$t("taking.sources.donation") };
      ws["M1"] = { v: this.$t("taking.sources.economic") };
      ws["S1"] = { v: this.$t("taking.sources.comment") };

      ws["!merges"] = [
        XLSX.utils.decode_range("C1:F1"),
        XLSX.utils.decode_range("H1:L1"),
        XLSX.utils.decode_range("M1:N1"),
        XLSX.utils.decode_range("S1:Y1"),
      ];

      XLSX.utils.book_append_sheet(wb, ws, "Einnahmen");
      XLSX.writeFile(wb, filename);
    },
    create() {
      this.$router.push({ name: "TakingsAdd" });
    },
    showRemove(value) {
      if (value.event.id === "" && value.deposit_units.length === 0) {
        return true;
      }
      return false;
    },
    incUpdateCount() {
      this.updateCount += 1;
    },
    edit(value) {
      return "/finances/takings/edit/" + value;
    },
    remove(value) {
      if (!confirm(this.$t("taking.delete.confirm"))) {
        return false;
      }
      this.$store
        .dispatch({ type: "takings/deleteByID", data: value })
        .then(() => {
          this.$store.dispatch({
            type: `${this.store}/request`,
            data: { inital: true, abort: true },
          });
        });
    },
    resetFilter() {
      this.filter = { ...this.currentFilter };
    },
    formatMoneyStatus(values, key) {
      if (values.no_income) {
        if (key === "confirmed") {
          return this.$t("taking.list.no_income");
        }
        return "";
      } else {
        let total =
          values.open.amount + values.wait.amount + values.confirmed.amount;

        if (
          (total > 0 && values[key].amount > 0) ||
          (total === 0 && key === "open")
        ) {
          return this.formatMoney(values[key]);
        }

        return "-";
      }
    },
    setCurrent(value) {
      if (this.current && this.current.id == value.id) {
        this.$store.commit("takings/current", null);
      } else {
        this.$store.commit("takings/current", value);
      }
    },
    async sort(col) {
      await this.$store.dispatch({
        type: this.store + "/sort",
        col,
      });
      return;
    },
    dataOfTaking(value) {
      if (value === 0) {
        return "-";
      } else {
        return this.date(value);
      }
    },
  },
};
</script>
